'use client';

import classnames from 'classnames';
import {
  SignInNav as V3SignInNav,
  SignInNavProps,
} from '@stadionhq-v3/base-ui';
import styles from './signInNav.module.scss';
import buttonStyles from '../../atoms/button/button.module.scss';

const SignInNav = ({
  /* props */
  classNames,
  isSignedIn,
  onDark,
  ssoLink1,
  ssoLink2,
  myAccount,
  dropdownData,
  ...props
}: SignInNavProps & {
  onDark?: boolean;
}) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.signInNav,
      isSignedIn && styles.isSignedIn,
      onDark && styles.onDark,
    ],
    classNames
  );

  return (
    <V3SignInNav
      classNames={[classes]}
      isSignedIn={isSignedIn}
      ssoLink1={
        ssoLink1 && {
          ...ssoLink1,
          classNames: [classnames(styles.ssoLink)],
        }
      }
      ssoLink2={
        ssoLink2 && {
          ...ssoLink2,
          classNames: [classnames(styles.ssoLink)],
        }
      }
      myAccount={
        myAccount && {
          ...myAccount,
          classNames: [classnames(styles.myAccountTrigger)],
        }
      }
      dropdownData={
        dropdownData && {
          ...dropdownData,
          userData: dropdownData.userData
            ? {
                ...dropdownData.userData,
                detailsLink: dropdownData.userData?.detailsLink
                  ? {
                      ...dropdownData.userData.detailsLink,
                    }
                  : undefined,
              }
            : undefined,
          classNames: [classnames(styles.myAccountDropdownPanel)],
          signOutButton: {
            ...dropdownData.signOutButton,
            classNames: [
              classnames(
                buttonStyles.button,
                buttonStyles.buttonTokens,
                buttonStyles.medium,
                buttonStyles.primary
              ),
            ],
          },
        }
      }
      {...props}
    />
  );
};

export default SignInNav;
